<template>
  <div
    class="km-alert"
    :class="css"
  >
    <div
      v-if="finalShowIcon"
      class="km-alert__icon"
    >
      <slot name="icon">
        <icon :icon="finalIcon" />
      </slot>
    </div>
    <div class="km-alert__content">
      <div class="km-alert__message">
        <slot />
      </div>
      <slot name="underline">
        <div class="km-alert__underline" />
      </slot>
    </div>
  </div>
</template>

<script>
import Icon from '../icon'
import { DefaultCircleIconMap } from '../../core/KConstants'

export default {
  name: 'KAlert',
  components: { Icon },
  props: {
    // 主题：primary、secondary、success、warning、danger、light、dark
    type: {
      type: String,
      default: 'light',
    },
    // 是否显示icon，不通主题都有默认的icon
    showIcon: {
      type: Boolean,
      default: false,
    },
    // 自定义icon
    icon: {
      type: String,
      default: '',
    },
    // closable: {
    //   type: Boolean,
    //   default: false,
    // },
    raised: {
      type: Boolean,
      default: false,
    },
    // 居中显示
    center: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    css() {
      const result = {
        [`km-alert--${this.type}`]: true,
        [`km-alert--centered`]: this.center,
        'is-raised': this.raised,
      }
      if (this.$slots.underline) {
        result['km-alert--has-underline'] = true
      }

      return result
    },
    finalIcon() {
      if (this.$slots.icon) {
        return
      }

      if (this.icon) {
        return this.icon
      }

      if (this.showIcon) {
        return DefaultCircleIconMap[this.type] || DefaultCircleIconMap.primary
      }
      return null
    },
    finalShowIcon() {
      return this.$slots.icon || this.icon || this.showIcon
    },
  },
  mounted() {},
}
</script>
